const Menu = [
  // {
  //   title: 'Escritorio',
  //   group: 'main',
  //   icon: 'mdi-view-dashboard',
  //   name: 'Dashboard',
  //   hint: 'Resumen de las principales estadísticas del sistema'
  // },
  {
    title: 'Introducir matrícula/bastidor',
    group: 'main',
    icon: 'mdi-magnify-scan',
    name: 'Escaneo',
    excludeRoles: ['admin'],
    hint: 'Escaneo de matriculas'
  },
  {
    title: 'Vehículos',
    group: 'main',
    icon: 'mdi-car-convertible',
    name: 'Vehiculo',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de vehiculos'
  },
  {
    title: 'Movimientos',
    group: 'main',
    icon: 'mdi-car-arrow-right',
    name: 'Movimiento',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de los movimientos'
  },
  {
    title: 'Cesiones',
    group: 'main',
    icon: 'mdi-swap-horizontal',
    name: 'Cesión',
    excludeRoles: ['admin'],
    hint: 'Controle la gestion de las cesiones'
  },
  {
    title: 'Notificaciones',
    group: 'main',
    icon: 'mdi-bell',
    name: 'Notificaciones',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de las notificaciones'
  },
  {
    title: 'Comodatos',
    group: 'main',
    icon: 'mdi-text-box-multiple-outline',
    name: 'Commodato',
    roles: ['manage_dealer', 'descargar_comodato'],
    hint: 'Controle la gestion de los comodatos'
  },
  {
    title: 'Equipamientos ',
    group: 'main',
    icon: 'mdi-tools',
    name: 'Equipamiento',
    roles: ['admin'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Usuarios',
    group: 'main',
    icon: 'mdi-account-group',
    name: 'User',
    roles: ['manage_users', 'actualizar_usuario', 'agregar_usuario_normal', 'eliminar_usuario', 'admin'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  // {
  //   title: 'Administradores',
  //   group: 'main',
  //   icon: 'mdi-shield-account',
  //   name: 'AdminUser',
  //   roles: ['admin'],
  //   hint: 'Gestión de usuarios administradores del sistema'
  // },
  {
    title: 'Grúas',
    group: 'main',
    icon: 'mdi-tow-truck',
    name: 'Grua',
    roles: ['crear_grua', 'editar_grua'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Conductores',
    group: 'main',
    icon: 'mdi-account-tie',
    name: 'Driver',
    roles: ['crear_conductor', 'editar_conductor'],
    hint: 'Controle la gestion de los conductores'
  },
  {
    title: 'Ubicaciones',
    group: 'main',
    icon: 'mdi-map-marker',
    name: 'Ubicacion',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de las ubicaciones'
  },
  {
    title: 'Concesionarios',
    group: 'main',
    icon: 'mdi-store',
    name: 'Concesionario',
    roles: ['admin'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Colaboradores',
    group: 'main',
    icon: 'mdi-account-group',
    name: 'Colaborador',
    roles: ['admin'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Partners',
    group: 'main',
    icon: 'mdi-store',
    name: 'Partner',
    roles: ['admin'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'ChatBot',
    group: 'main',
    icon: 'mdi-robot',
    name: 'ChatBotAdmin',
    roles: ['admin'],
    hint: 'Conversaciones del ChatBot con IA'
  },
  {
    title: 'Configuración',
    group: 'main',
    icon: 'mdi-cog',
    name: 'Configuracion',
    hint: 'Ajustes del sistema'
  },
  {
    title: 'Asistente Virtual',
    group: 'main',
    icon: 'mdi-robot-outline',
    isChatbot: true,
    hint: 'Chatbot con IA de asistencia'
  }
]

export default Menu
